import React from "react";
import { Instagram, Mail, Phone, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/restaurant/logo.png";

export default function Footer() {
	const { t, i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	return (
		<footer className="bg-white text-gray-600">
			<div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
				{/* Logo + claim */}
				<div>
					<img src={logo} alt="Applaby" className="h-10 mb-4" />
					<p className="text-sm">{t("store.footer.claim")}</p>
				</div>

				{/* Menú */}
				<div className="flex flex-col gap-2 text-sm">
					<a href="/" className="hover:text-primary transition">
						{t("store.footer.menu.home")}
					</a>
					<a href="/tiendas/demo" className="hover:text-primary transition">
						{t("store.footer.menu.demo")}
					</a>
					<a
						href="/tiendas"
						onClick={(e) => {
							e.preventDefault();
							document.querySelector("#precios")?.scrollIntoView({
								behavior: "smooth",
							});
						}}
						className="hover:text-primary transition"
					>
						{t("store.footer.menu.pricing")}
					</a>
					<a
						href="https://applaby.com/terminos"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("store.footer.menu.terms")}
					</a>
					<a
						href="https://applaby.com/politica-privacidad"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("store.footer.menu.privacy")}
					</a>
				</div>

				{/* Contacto y redes */}
				<div className="flex flex-col gap-3 text-sm">
					<a
						href="mailto:info@applaby.com"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Mail className="w-4 h-4" /> info@applaby.com
					</a>
					<a
						href="tel:+34608916357"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Phone className="w-4 h-4" /> +34 608 916 357
					</a>
					<a
						href="https://www.instagram.com/applaby_es"
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Instagram className="w-5 h-5" /> @applaby_es
					</a>
				</div>
			</div>

			<div className="border-t border-gray-200 mt-10 mb-6 pt-6 text-xs text-gray-500 flex flex-col sm:flex-row items-center justify-center gap-4">
				<span>© {new Date().getFullYear()} Applaby. {t("store.footer.rights")}</span>
				<div className="flex items-center gap-2">
					<Globe className="w-4 h-4 text-gray-400" />
					<div className="flex gap-1">
						<button
							onClick={() => changeLanguage("es")}
							className={`px-2 py-1 rounded text-xs transition ${
								i18n.language === "es"
									? "bg-primary text-white"
									: "text-gray-400 hover:text-gray-600"
							}`}
						>
							ES
						</button>
						<button
							onClick={() => changeLanguage("en")}
							className={`px-2 py-1 rounded text-xs transition ${
								i18n.language === "en"
									? "bg-primary text-white"
									: "text-gray-400 hover:text-gray-600"
							}`}
						>
							EN
						</button>
						<button
							onClick={() => changeLanguage("ca")}
							className={`px-2 py-1 rounded text-xs transition ${
								i18n.language === "ca"
									? "bg-primary text-white"
									: "text-gray-400 hover:text-gray-600"
							}`}
						>
							CA
						</button>
					</div>
				</div>
			</div>
		</footer>
	);
}
